import React from 'react'
import {Switch, Route, useRouteMatch, Link} from 'react-router-dom'
import ScrollToTop from '../Components/ScrollToTop'
import NavBar from '../Components/NavBar'
import List from '../Components/List'
import Tags from "../Components/Tags"
import './layout.css'
import './Projects.css';

import thumbnail_hci from './../img/project_thumbnail/hci.png'
import thumbnail_tech_car from './../img/project_thumbnail/tech_car.png'
import thumbnail_tech_bit from './../img/project_thumbnail/tech_bit.png'
import thumbnail_tech_ashore from './../img/project_thumbnail/design_ashore.png'
import thumbnail_design_joeed from './../img/project_thumbnail/design_joeed.png'
import thumbnail_design_deer from './../img/project_thumbnail/design_deer.png'
import thumbnail_design_fourier from './../img/project_thumbnail/design_fourier.png'
import thumbnail_design_flake from './../img/project_thumbnail/design_flake.png'
import thumbnail_web_tedx from './../img/project_thumbnail/web_tedx.png'
import thumbnail_web_design from './../img/project_thumbnail/web_design.png'
import thumbnail_web_splat from './../img/project_thumbnail/web_splat.png'
import thumbnail_illust_food from './../img/project_thumbnail/illust_food.png'
import thumbnail_illust_japan from './../img/project_thumbnail/illust_japan.png'
import thumbnail_illust_berlin from './../img/project_thumbnail/illust_berlin.png'
import thumbnail_illust_life from './../img/project_thumbnail/illust_life.png'


const project_categories_links = ['hci-texel',
'tech-EECSCapstone','tech-CSLlab','tech-speaker',
'design-gamecontroller','design-papermodel','design-lighting','design-chair',
'web-tedx','web-humancenterdesign','web-splat',
'illust-food','illust-japan','illust-berlin'//,'illust-daily'
]

const tags = {
    hci: <Tags color="red" text="HCI"/>,
    tech: <Tags color="blue" text="Technical"/>,
    design: <Tags color="orange" text="design"/>,
    web: <Tags color="blue" text="Web"/>,
    illust: <Tags color="orange" text="Illustration"/>
}

const links = {
    hci: [
        <ProjectsLink img={thumbnail_hci} tag='hci' link='hci-texel'
        title="TexelBlocks: Dynamic Surfaces for Physical Interactions"/>
    ],
    tech: [
        <ProjectsLink img={thumbnail_tech_car} tag='tech' link='tech-EECSCapstone'
        title="Autonomous Car Course Project Design"/>,
        <ProjectsLink img={thumbnail_tech_bit} tag='tech' link='tech-CSLlab'
        title="Computer System Laboratory Lab Project Design"/>,
        <ProjectsLink img={thumbnail_tech_ashore} tag='tech' link='tech-speaker'
        title="Ashore: ocean-friendly in-home speaker"/> 
    ],
    design: [
        <ProjectsLink img={thumbnail_design_joeed} tag="design" link='design-gamecontroller'
        title="JOEED: The Game Controller"/>,
        <ProjectsLink img={thumbnail_design_deer} tag="design" link='design-papermodel'
        title="Animal Low-poly paper model"/>,
        <ProjectsLink img={thumbnail_design_fourier} tag="design" link='design-lighting'
        title="Fourier: wave form chandelier"/>,
        <ProjectsLink img={thumbnail_design_flake} tag="design" link='design-chair'
        title="Flake: chair design"/>,
        <ProjectsLink img={thumbnail_tech_ashore} tag='tech' link='tech-speaker'
        title="Ashore: ocean-friendly in-home speaker"/> 
    ],
    web: [
        <ProjectsLink img={thumbnail_web_tedx} tag='web' link='web-tedx'
        title="TedxNationalTaiwanUniversity online annual event"/>,
        <ProjectsLink img={thumbnail_web_design} tag='web' link='web-humancenterdesign'
        title="Design method introduction"/>,
        <ProjectsLink img={thumbnail_web_splat} tag='web' link='web-splat'
        title="Splat.io"/>
    ],
    illust: [
        <ProjectsLink img={thumbnail_illust_food} tag='illust' link='illust-food'
        title="Taiwan food"/>,
        <ProjectsLink img={thumbnail_illust_japan} tag='illust' link='illust-japan'
        title="Traveling - Japan 2019 Winter"/>,
        <ProjectsLink img={thumbnail_illust_berlin} tag='illust' link='illust-berlin'
        title="Traveling - Berlin 2019 Summer"/>
        /*
        <ProjectsLink img={thumbnail_illust_life} tag='illust' link='illust-daily'
        title="Daily life"/>
        */
    ]
}

const intro = {
    all: '',
    hci:<p>
        My current research interest is focused on <b>tangible interfaces</b>.
        I am interrested in building interactive devices that propose great design space and lead us to explore the real world around us.
        I have been doing research in National Taiwan University HCI Lab since 2020/3, under the supervisor of <a href="http://www.lungpancheng.tw/">Professor Lung-Pan Cheng</a>.
        </p>,
    tech:<p>
        I have been focusing on studying embedded system, circuit implementation, control system, socket programming.
        </p>,
    design: <p>
                I am <b>minoring in Industrial Design</b> in the Design department of National Taiwan University of Science and Technology, which is in a alliance with National Taiwan University (where I major electrical engineering in).
                <br/>
                I have earned 15 units so far (GPA 4.0/4.0), and I plan to earn 23 units in total.
                From these courses, I acquired <b>the skills of designing and hand-making 3D models</b>.
                I also dig into using <b>Rinoceros both the software itself and with Grasshopper</b>.
                <br/>
            </p>,
    web:<p>
            Designing a website is just like doing visual design, but with a lot more interactability. I enjoy desiging UI/UX of a website, and I also enjoy carrying out my design into realty with coding.
            <br/>
            I did a UX design intern in National Taiwan University Digital Learning Center in 2019 summer, which we worked on evaluating and improving the new online course system that impacts thousands of students in the university.
            <br/>
            I was also the teaching assistant of the Web Programming course (2020, EE3035, Prof. Chung-Yang Huang).
        </p>,
    illust: ''
}


export default class Projects extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            all: true,
            hci: false,
            tech: false,
            design: false,
            web: false,
            illust: false,
            chosen: 'all'
        }
    }
    setChosen(name){
        this.setState({
            all: name==='all',
            hci: name==='hci',
            tech: name==='tech',
            design: name==='design',
            web: name==='web',
            illust: name==='illust',
            chosen: name
        })
    }
    renderProjectLinks(name){
        return links[name]
    }
    renderIntro(){
        return(intro[this.state.chosen])
    }
    render(){
        return(
            <div id="projects">


                
                {/*
                <div className="projects-catagory-tag">
                    <Tags onClick={() => this.setChosen('all')} color="gray" text="All" isChosen={this.state.all}/>
                    <Tags onClick={() => this.setChosen('hci')} color="red" text="Human-Computer Interaction" isChosen={this.state.hci}/>
                    <Tags onClick={() => this.setChosen('tech')} color="blue" text="Technical" isChosen={this.state.tech}/>
                    <Tags onClick={() => this.setChosen('design')} color="orange" text="Industrial Design" isChosen={this.state.design}/>
                    <Tags onClick={() => this.setChosen('web')} color="blue" text="Web Programming" isChosen={this.state.web}/>
                    <Tags onClick={() => this.setChosen('illust')} color="orange" text="Illustration" isChosen={this.state.illust}/>
                </div>
                
                <h3>Design and Modeling (Awaiting Updates...)</h3>
                <div className='proj-section'>
                    {links["design"]}
                </div>

                <h3>Web Design</h3>
                <div className='proj-section'>
                    {links["web"]}
                </div>

                <h3>Illustration</h3>
                <div className='proj-section'>
                    {links["illust"]}
                </div>

                */}

            </div>
        )
    }
}

function ProjectsLink(props){
    var cn = "project-links-hover " //+ "tags-cover-" + props.tag
    return(
        <Link to={"/" + props.link} className="project-links">
            <div className={cn}></div>
            <div className="project-links-hover2"></div>
            <img src={props.img} />
            <h1>{props.title}</h1>
            {/*
            <div className='project-links-tags'>
                {tags[props.tag]}
            </div>
            */}
        </Link>
    )
}
